import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { Product } from '../types';
import { getProductsByProductFamilyId } from '../../../api/resilience/resilience.api';
import { DEFAULT_STALE_TIME_MS, DEFAULT_CACHE_TIME_MS } from '../constant';
import { useIsoLanguageCode } from '../../../utils/hooks/useIsoLanguageCode';

export function useProductsByProductFamilyId(productFamilyId?: string) {
  const isoLanguageCode = useIsoLanguageCode();

  return useQuery<Product[], AxiosError>({
    queryKey: [
      `/v1/configurator/product-families/{productFamilyId}/products`,
      { productFamilyId, isoLanguageCode },
    ],
    queryFn: async () => {
      if (!productFamilyId) {
        throw new Error('productFamilyId is required to fetch pricing');
      }

      const res = await getProductsByProductFamilyId(productFamilyId, {
        params: { isoLanguageCode },
      });
      return res.data;
    },
    enabled: !!productFamilyId,
    refetchOnWindowFocus: true,
    staleTime: DEFAULT_STALE_TIME_MS,
    cacheTime: DEFAULT_CACHE_TIME_MS,
  });
}
